import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { useBoolean } from 'ahooks';
import { Button, Col, Input, Row } from 'antd';

import { DeleteAction, SaveAction } from 'components';

import { usePostRequest } from 'hooks';

import { AggregatedProductIdentity, AggregatedProductIdentityCreate } from 'codegen';

export const AddNewIdentityButton = ({
  record,
  refresh,
}: {
  record: AggregatedProductIdentity & { id: number },
  refresh: () => void,
}) => {
  const { productId } = useParams();

  const [value, setValue] = useState('');
  const [addNew, { setTrue, setFalse }] = useBoolean(false);

  const [postIdentities, { loading }] = usePostRequest<AggregatedProductIdentity, AggregatedProductIdentityCreate>({
    url: `/products/details/${productId}/identities`,
    options: {
      onSuccess: () => {
        refresh();
        setFalse();
        setValue('');
      },
    },
  });

  return (
    <div className='mt-2'>
      {addNew && (
        <Row align='middle' justify='space-between'>
          <Col>
            <Input
              size='small'
              value={value}
              onChange={({ target }) => setValue(target.value)}
              className='bg-white'
            />
          </Col>

          <Col>
            <SaveAction
              loading={loading}
              disabled={!value}
              onConfirm={() => postIdentities({
                payload: {
                  ...record,
                  values: [{ value, isActive: true }],
                },
              })}
            />

            <DeleteAction
              disabled={loading}
              onConfirm={() => {
                setFalse();
                setValue('');
              }}
            />
          </Col>
        </Row>
      )}

      <Button
        size='small'
        type='link'
        className='p-0'
        onClick={setTrue}
        disabled={addNew}
      >
        Add new
      </Button>
    </div>
  );
};
